import React from 'react';
import { Common } from '../../core/common';
import Translator from '../../core/i18n';
const noNotificationImage = `${process.env.PUBLIC_URL}/images/notifications/no_notification.png`;
const emptySelectImage =`${process.env.PUBLIC_URL}/images/emptySelect/emptySelect.svg`;
let _common: Common;
const T = Translator.create();

interface NotFoundProps {
  message: string;
  type?: 'emptySelect' | 'noData'; // Belirli tipler için
  subtext?: string;
}

export class NotFound extends React.Component<NotFoundProps, any> {
  constructor(props: NotFoundProps) {
    super(props);
    _common = new Common();
  }

  public render() {
    const imageSrc =this.props.type === 'emptySelect' ? emptySelectImage : noNotificationImage;

    return (
      <div className='not_found_component'>
        <img src={imageSrc}  alt="Not Found Icon" />
        <span style={{fontWeight:'500'}}>{this.props.message}</span>
        <span style={{fontWeight:'400',opacity:'.75'}}>{this.props.subtext}</span>
      </div>
    );
  }
}

export default NotFound;
